var React = require('react');

function Warning (props) {
    return React.createElement("svg",props,React.createElement("g",{"opacity":"0.8"},[React.createElement("path",{"d":"M20 35C28.2843 35 35 28.2843 35 20C35 11.7157 28.2843 5 20 5C11.7157 5 5 11.7157 5 20C5 28.2843 11.7157 35 20 35Z","stroke":"#FFCC00","strokeWidth":"2","strokeMiterlimit":"10","key":0}),React.createElement("path",{"d":"M20 12.5V21.25","stroke":"#FFCC00","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M20 28.75C21.0355 28.75 21.875 27.9105 21.875 26.875C21.875 25.8395 21.0355 25 20 25C18.9645 25 18.125 25.8395 18.125 26.875C18.125 27.9105 18.9645 28.75 20 28.75Z","fill":"#FFCC00","key":2})]));
}

Warning.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = Warning;

Warning.default = Warning;
